import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconRewards from '@/assets/icons/heroIcons/Rewards.svg';
import Hero from '@/sections/Hero';
import MoreInfoSection from '@/sections/MoreInfo';
import { FaqIntro } from '@/sections/FaqIntro';
import { Button, DownloadButton } from '@/components/buttons';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { SectionHeadline } from '@/components/SectionHeadline';
import { ContentContainer } from '@/components/layout';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { useTranslation, Trans } from 'react-i18next';
import { LINKS } from '@/constants/links';
import React from 'react';
import Image from 'next/image';
import { Box } from '@/sections/pricing/Box';
import { BoxRow } from '@/sections/pricing/BoxRow';
import { DelayTable } from '@/sections/pricing/DelayTable';
import { PricingDocuments } from '@/sections/pricing/PricingDocuments';
import { getPageBannerBySlug, PageBanner } from '@/api/sanity/pageBanners';
import { SeoHeader } from '@/components/SeoHeader';
import { Text } from '@/components/typography';
import { Link } from '@/components/links';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconUser from '@/assets/icons/heroIcons/User-group.svg';
import { mergeClasses } from '@/utils/style';
import { FILES } from '@/constants/files';
import { useRouter } from 'next/router';
import IconShoppingCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import InstallmentsInfo from '@/sections/pricing/InstallmentsInfo';
import { getSectionAnchorId } from '@/utils/anchors';
import MaxiInfo from '@/sections/pricing/MaxiInfo';
import DeferredPaymentInfo from '@/sections/pricing/DeferredPaymentInfo';
import PayInThreeInfo from '@/sections/pricing/PayInThreeInfo';
import { ProductTable } from '@/sections/pricing/ProductTable';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import LoanInfo from '@/sections/pricing/LoanInfo';
interface Props extends IntlProps {
  pageBanner: PageBanner | null;
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(100);
  const {
    pageBanner,
    menuPromoBanners
  } = t0;
  usePageView("pricing");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["pricing", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const isCsLanguage = useIsSelectedLanguage("cs");
  const isHuLanguage = useIsSelectedLanguage("hu");
  const {
    locale
  } = useRouter();
  let t2;
  if ($[1] !== t) {
    t2 = t("seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = pageBanner?.videoId;
  let t6;
  if ($[8] !== pageBanner?.title || $[9] !== t) {
    t6 = pageBanner?.title ?? t("banner.title");
    $[8] = pageBanner?.title;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== pageBanner?.text || $[12] !== t) {
    t7 = pageBanner?.text ?? t("banner.text");
    $[11] = pageBanner?.text;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = pageBanner && !isHuLanguage ? pageBanner.buttons : null;
  let t9;
  if ($[14] !== locale) {
    t9 = FILES(locale);
    $[14] = locale;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = t9.currentPricingDocument;
  let t11;
  if ($[16] !== t) {
    t11 = t("pricing.fileCurrent");
    $[16] = t;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t9.currentPricingDocument) {
    t12 = <div className="flex flex-col items-center gap-2"><DownloadButton to={t10} testId="pricing" analyticsParam="pricing">{t11}</DownloadButton></div>;
    $[18] = t11;
    $[19] = t9.currentPricingDocument;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = pageBanner?.image?.url ?? "/images/sections/pricing/hero/hero.png";
  let t14;
  if ($[21] !== pageBanner?.image?.alt || $[22] !== t) {
    t14 = pageBanner?.image?.alt ?? t("banner.title");
    $[21] = pageBanner?.image?.alt;
    $[22] = t;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13 || $[25] !== t14) {
    t15 = {
      url: t13,
      alt: t14
    };
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const t16 = pageBanner?.variant || "mascots";
  let t17;
  if ($[27] !== t12 || $[28] !== t15 || $[29] !== t16 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8) {
    t17 = <Hero videoId={t5} title={t6} text={t7} buttons={t8} customButton={t12} image={t15} variant={t16} />;
    $[27] = t12;
    $[28] = t15;
    $[29] = t16;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="bg-blue-50"><SectionDelimiter color="bg-blue-100" background="bg-transparent" /></div>;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="bgCircle absolute top-1/4 left-0 hidden -translate-x-1/4 -translate-y-1/2 rotate-90 lg:block" />;
    t20 = <div className="bgCircle absolute right-0 bottom-1/4 hidden translate-x-1/4 -translate-y-1/4 lg:block" />;
    $[36] = t19;
    $[37] = t20;
  } else {
    t19 = $[36];
    t20 = $[37];
  }
  let t21;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = getSectionAnchorId("products");
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t) {
    t22 = t("products.title");
    $[39] = t;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t22) {
    t23 = <SectionHeadline className="mb-4 md:mb-5" anchorKey="pricing.products.title">{t22}</SectionHeadline>;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t) {
    t24 = t("products.text");
    $[43] = t;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t24) {
    t25 = <Text variant="p2" className="mb-10 text-center text-gray-800 lg:mb-12">{t24}</Text>;
    $[45] = t24;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== isCsLanguage) {
    t26 = <div className="flex flex-col gap-4">{isCsLanguage ? <><MaxiInfo /><DeferredPaymentInfo /><PayInThreeInfo /><InstallmentsInfo /><LoanInfo /></> : <ProductTable />}</div>;
    $[47] = isCsLanguage;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = LINKS();
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  const t28 = t27.allProducts;
  let t29;
  if ($[50] !== t) {
    t29 = t("products.cta");
    $[50] = t;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== t29) {
    t30 = <Button to={t28} testId="pricingAllProducts" analyticsParam="pricingAllProducts" size="lg" variant="primary" className="mt-12 lg:mt-14" align="center">{t29}</Button>;
    $[52] = t29;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] !== t23 || $[55] !== t25 || $[56] !== t26 || $[57] !== t30) {
    t31 = <div className="py-10 lg:py-20" id={t21}>{t23}{t25}{t26}{t30}</div>;
    $[54] = t23;
    $[55] = t25;
    $[56] = t26;
    $[57] = t30;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] !== isCsLanguage || $[60] !== t) {
    t32 = isCsLanguage && <div className="py-10 lg:py-20" id={getSectionAnchorId("maxi")}><SectionHeadline className="mb-4 md:mb-5" anchorKey="pricing.maxi.title">{t("maxi.title")}</SectionHeadline><Text variant="p2" className="mb-10 text-center text-gray-800 lg:mb-12">{t("maxi.text")}</Text><Box><BoxRow left={t("maxi.table.1.title")} right={t("maxi.table.1.text")} /><BoxRow left={t("maxi.table.2.title")} right={t("maxi.table.2.text")} /><BoxRow left={t("maxi.table.3.title")} right={t("maxi.table.3.text")} /><BoxRow left={t("maxi.table.4.title")} right={t("maxi.table.4.text")} /><BoxRow left={t("maxi.table.5.title")} right={t("maxi.table.5.text")} /><BoxRow left={t("maxi.table.6.title")} right={t("maxi.table.6.text")} /><BoxRow left={t("maxi.table.7.title")} right={t("maxi.table.7.text")} /><BoxRow left={t("maxi.table.8.title")} right={t("maxi.table.8.text")} /><BoxRow left={t("maxi.table.9.title")} right={t("maxi.table.9.text")} /><BoxRow left={t("maxi.table.10.title")} right={t("maxi.table.10.text")} /><BoxRow left={t("maxi.table.11.title")} right={t("maxi.table.11.text")} /></Box></div>;
    $[59] = isCsLanguage;
    $[60] = t;
    $[61] = t32;
  } else {
    t32 = $[61];
  }
  let t33;
  if ($[62] !== isCsLanguage || $[63] !== t) {
    t33 = isCsLanguage && <div className="pt-10 pb-14 lg:pt-20 lg:pb-32" id={getSectionAnchorId("delayTable")}><SectionHeadline className="mb-4 md:mb-5" anchorKey="pricing.delayTable.title">{t("delayTable.title")}</SectionHeadline><Text variant="p2" className="mb-10 text-center text-gray-800 lg:mb-12">{t("delayTable.text")}</Text><DelayTable /></div>;
    $[62] = isCsLanguage;
    $[63] = t;
    $[64] = t33;
  } else {
    t33 = $[64];
  }
  let t34;
  if ($[65] !== t31 || $[66] !== t32 || $[67] !== t33) {
    t34 = <div className="relative z-30 bg-blue-100 px-4">{t19}{t20}<div className="relative z-10 mx-auto max-w-[60.5rem]">{t31}{t32}{t33}</div></div>;
    $[65] = t31;
    $[66] = t32;
    $[67] = t33;
    $[68] = t34;
  } else {
    t34 = $[68];
  }
  let t35;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <SectionDelimiter color="bg-blue-50" background="bg-blue-100" />;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  let t36;
  if ($[70] !== isCsLanguage || $[71] !== t) {
    t36 = isCsLanguage && <><div className="relative overflow-hidden bg-blue-50"><div className="bgCircle absolute right-0 bottom-0 hidden translate-x-1/2 lg:block" /><div className="relative z-10"><div className="px-4 py-10 lg:py-20" id={getSectionAnchorId("delaySection")}><ContentContainer><div className="flex flex-col items-center gap-12 lg:flex-row lg:gap-10"><div className="w-full shrink"><Image src="/images/sections/pricing/cs/app.png" alt={t("delaySection.title")} width={471} height={471} className="md:max-w-fullg mx-auto max-w-[90%]" /></div><div className="w-[29.25rem] max-w-full shrink-0"><SectionHeadline className="mb-4 lg:text-left" anchorKey="pricing.delaySection.title">{t("delaySection.title")}</SectionHeadline><Text variant="p2" className="mb-4 text-center lg:text-left">{t("delaySection.texts.1")}</Text><Text variant="p2" className="text-center lg:text-left">{t("delaySection.texts.2")}</Text><Button to={LINKS().postponeDueDate} testId="pricingPostponeDueDate" analyticsParam="pricingPostponeDueDate" size="lg" variant="primary" className="mx-auto mt-10 lg:mx-0">{t("delaySection.cta")}</Button></div></div></ContentContainer></div><div id="oldDocuments" className="px-4 pt-10 pb-20 text-center lg:pt-20 lg:pb-40"><SectionHeadline className="mb-12 lg:mb-16" anchorKey="pricing.pricing.title">{t("pricing.title")}</SectionHeadline><PricingDocuments /></div></div></div><SectionDelimiter color="bg-blue-100" background="bg-blue-50" /></>;
    $[70] = isCsLanguage;
    $[71] = t;
    $[72] = t36;
  } else {
    t36 = $[72];
  }
  const t37 = isCsLanguage ? "bg-blue-100" : "bg-blue-50";
  let t38;
  if ($[73] !== t37) {
    t38 = mergeClasses("relative overflow-hidden", t37);
    $[73] = t37;
    $[74] = t38;
  } else {
    t38 = $[74];
  }
  let t39;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = LINKS();
    $[75] = t39;
  } else {
    t39 = $[75];
  }
  let t40;
  if ($[76] !== isHuLanguage) {
    t40 = isHuLanguage ? LINKS().faqCategory("vasarlas-harom-reszletben") : LINKS().faqCategory("dalsi-caste-otazky");
    $[76] = isHuLanguage;
    $[77] = t40;
  } else {
    t40 = $[77];
  }
  let t41;
  if ($[78] !== t40) {
    t41 = <Link to={t40} analyticsParam="faqPricing" testId="faqPricing" />;
    $[78] = t40;
    $[79] = t41;
  } else {
    t41 = $[79];
  }
  let t42;
  if ($[80] !== t || $[81] !== t41) {
    t42 = <div className="py-10 lg:py-20"><FaqIntro link={t39.faq} text={<Trans i18nKey="faq" t={t}>{t41}</Trans>} /></div>;
    $[80] = t;
    $[81] = t41;
    $[82] = t42;
  } else {
    t42 = $[82];
  }
  let t43;
  if ($[83] !== isCsLanguage || $[84] !== t) {
    t43 = <MoreInfoSection buttons={isCsLanguage ? [{
      analyticsParam: "pricingMoreInfoDeferredPayment",
      icon: <IconDeferredPayment className="fillButtonIcon" />,
      testId: "pricingMoreInfoDeferredPayment",
      title: t("core:link.deferredPayment"),
      to: LINKS().deferredPayment
    }, {
      analyticsParam: "pricingMoreInfoRevolvingApplication",
      icon: <IconMaxi className="fillButtonIcon" />,
      testId: "pricingMoreInfoRevolvingApplication",
      title: t("core:products.revolving"),
      to: LINKS().revolving
    }, {
      analyticsParam: "pricingMoreInfoPayInThree",
      icon: <IconThird className="fillButtonIcon" />,
      testId: "pricingMoreInfoPayInThree",
      title: t("core:products.payInThree"),
      to: LINKS().payInThree
    }, {
      analyticsParam: "pricingMoreInfoRewards",
      icon: <IconRewards className="fillButtonIcon" />,
      testId: "pricingMoreInfoRewards",
      title: t("core:products.rewards"),
      to: LINKS().rewards
    }] : [{
      analyticsParam: "pricingMoreInfoPayInThree",
      icon: <IconThird className="fillButtonIcon" />,
      testId: "pricingMoreInfoPayInThree",
      title: t("core:products.payInThree"),
      to: LINKS().payInThree
    }, {
      analyticsParam: "pricingeMoreWhereToShop",
      icon: <IconShoppingCart className="fillButtonIcon" />,
      testId: "pricingMoreWhereToShop",
      title: t("core:products.whereToShop"),
      to: LINKS().whereToShop
    }, {
      analyticsParam: "pricingMobileApp",
      icon: <IconMobile className="fillButtonIcon" />,
      testId: "pricingMoreInfoMobileApp",
      title: t("core:products.mobileApp"),
      to: LINKS().mobileApp
    }, {
      analyticsParam: "pricingMoreInfoAboutCompany",
      icon: <IconUser className="fillButtonIcon" />,
      testId: "pricingMoreInfoAboutCompany",
      title: t("core:link.aboutUs"),
      to: LINKS().aboutCompany
    }]} />;
    $[83] = isCsLanguage;
    $[84] = t;
    $[85] = t43;
  } else {
    t43 = $[85];
  }
  let t44;
  if ($[86] !== t42 || $[87] !== t43) {
    t44 = <div className="relative z-10">{t42}{t43}</div>;
    $[86] = t42;
    $[87] = t43;
    $[88] = t44;
  } else {
    t44 = $[88];
  }
  let t45;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[89] = t45;
  } else {
    t45 = $[89];
  }
  let t46;
  if ($[90] !== t38 || $[91] !== t44) {
    t46 = <div className={t38}>{t44}{t45}</div>;
    $[90] = t38;
    $[91] = t44;
    $[92] = t46;
  } else {
    t46 = $[92];
  }
  let t47;
  if ($[93] !== menuPromoBanners || $[94] !== t17 || $[95] !== t34 || $[96] !== t36 || $[97] !== t4 || $[98] !== t46) {
    t47 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t17}{t18}{t34}{t35}{t36}{t46}</Layout>;
    $[93] = menuPromoBanners;
    $[94] = t17;
    $[95] = t34;
    $[96] = t36;
    $[97] = t4;
    $[98] = t46;
    $[99] = t47;
  } else {
    t47 = $[99];
  }
  return t47;
}
export const getStaticProps = (async ctx => {
  return {
    props: {
      pageBanner: await getPageBannerBySlug('pricing'),
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'pricing']))
    }
  };
}) satisfies GetStaticProps<Props>;